import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconMinus(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M5 12C5 11.4477 5.44772 11 6 11H18C18.5523 11 19 11.4477 19 12C19 12.5523 18.5523 13 18 13H6C5.44772 13 5 12.5523 5 12Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
